/**
 * Das Zählwerk.
 *
 * Der Ausgleichsbetrag ist die eine Zahl, wegen der die App geöffnet wird.
 * Sie wird darum in dem Instrument gesetzt, in dem in diesem Auto ohnehin
 * die wichtigen Zahlen stehen: dem mechanischen Kilometerzähler.
 */

export function Zaehlwerk({ betrag }: { betrag: number }) {
  const zeichen = betrag.toFixed(2).replace('.', ',').split('');

  return (
    <span className="walzen" role="img" aria-label={`${betrag.toFixed(2)} Euro`}>
      {zeichen.map((z, i) => (
        <span
          key={i}
          className={z === ',' ? 'walze walze--trenner' : 'walze'}
          aria-hidden="true"
        >
          {z}
        </span>
      ))}
      <span className="walze walze--einheit" aria-hidden="true">
        €
      </span>
    </span>
  );
}

export function Schild({
  schuldner,
  glaeubiger,
}: {
  schuldner: string;
  glaeubiger: string;
}) {
  return (
    <div className="schild">
      <span className="schild__name">{schuldner}</span>
      <span className="schild__pfeil" aria-hidden="true">
        →
      </span>
      <span className="schild__name">{glaeubiger}</span>
      <span>schuldet</span>
    </div>
  );
}
